import { render, staticRenderFns } from "./LearnMoreTest.vue?vue&type=template&id=2b793b00"
import script from "./LearnMoreTest.vue?vue&type=script&lang=js"
export * from "./LearnMoreTest.vue?vue&type=script&lang=js"
import style0 from "./LearnMoreTest.vue?vue&type=style&index=0&id=2b793b00&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports